// libs
import styled from 'styled-components'

const Wrapper = styled('div')`
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`

export { Wrapper }
